import { render, staticRenderFns } from "./PointsIssuanceList.vue?vue&type=template&id=f1823322&scoped=true&"
import script from "./PointsIssuanceList.vue?vue&type=script&lang=js&"
export * from "./PointsIssuanceList.vue?vue&type=script&lang=js&"
import style0 from "./PointsIssuanceList.vue?vue&type=style&index=0&id=f1823322&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1823322",
  null
  
)

export default component.exports